import CartPanelActiveHotelTile from './CartPanelActiveHotelTile'
import CartPanelNeedsDatesTile from './CartPanelNeedsDatesTile'
import CartPanelDurationUnavailableTile from './CartPanelDurationUnavailableTile'
import type { CartPanelAccommodationItem } from '../hooks/useCartPanelItems'

interface Props {
  item: CartPanelAccommodationItem
  onToggleInclude: (item: CartPanelAccommodationItem) => void
  onChangeRoom: (item: CartPanelAccommodationItem) => void
  onSetDates: () => void
  onAdjustDays: (item: CartPanelAccommodationItem) => void
  onDelete: (item: CartPanelAccommodationItem) => void
  isStreaming: boolean
}

function CartPanelHotelTileDispatcher({
  item,
  onToggleInclude,
  onChangeRoom,
  onSetDates,
  onAdjustDays,
  onDelete,
  isStreaming,
}: Props) {
  switch (item.cartStatus) {
    case 'active':
    case 'not_synced':
      return (
        <CartPanelActiveHotelTile
          item={item}
          onToggleInclude={onToggleInclude}
          onChangeRoom={onChangeRoom}
          onDelete={onDelete}
          isStreaming={isStreaming}
        />
      )
    case 'needs_dates':
    case 'pending_hydration':
      return (
        <CartPanelNeedsDatesTile
          item={item}
          onToggleInclude={onToggleInclude}
          onSetDates={onSetDates}
          onChangeRoom={onChangeRoom}
          onDelete={onDelete}
          isStreaming={isStreaming}
        />
      )
    case 'duration_unavailable':
      return (
        <CartPanelDurationUnavailableTile
          item={item}
          onToggleInclude={onToggleInclude}
          onAdjustDays={onAdjustDays}
          onChangeRoom={onChangeRoom}
          onDelete={onDelete}
          isStreaming={isStreaming}
        />
      )
    default:
      return undefined
  }
}

export default CartPanelHotelTileDispatcher
